export const DATE_FORMAT_API: string = 'yyyy-MM-dd'
export const DATE_FORMAT_DISPLAY: string = 'd MMM yyyy'

export const DUE_DATE_PENDING_TEXT: string = 'Pending'

export const CONTAINER_STYLES = {
  maxWidth: '960px',
  padding: '32px',
  gap: '32px'
}
